import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31bccfc7"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "Veja nossas ofertas", -1 /* HOISTED */))
const _hoisted_2 = { class: "arrow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "see-offers",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('seeMoreOffers')))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["FontAwesomeIcon"], {
        icon: $setup.Icons.imported.faCaretDown,
        class: "caret-down"
      }, null, 8 /* PROPS */, ["icon"])
    ])
  ]))
}